import { call, put, takeEvery } from 'redux-saga/effects';
import { failurePut } from '../../app/failurePut';
import { getRequest, postRequest } from '../../app/request';
import parseAccountName from "../../utils/parseAccountName.js";
import { pushGtmEventAction } from "../GoogleTagManager/googleTagManagerActions.js";
import {
    getNewLifeAccountsFailure,
    getNewLifeAccountsSuccess,
    setNewLifeRespawnFailure,
    setNewLifeRespawnSuccess
} from "./bonusesActions.js";
import { GET_NEW_LIFE_ACCOUNTS_START, SET_NEW_LIFE_RESPAWN_START } from "./bonusesConstants.js";

export function* getNewLifeAccountsSaga() {
    try {
        const data = yield call(getRequest, '/user/bonus/new-life/list');
        yield put(getNewLifeAccountsSuccess(data));
    } catch (e) {
        yield call(failurePut, e, getNewLifeAccountsFailure);
    }
}

export function* setNewLifeRespawnSaga({ payload }) {
    const parsedAccount = parseAccountName(payload.accountCode);
    try {
        const data = yield call(postRequest, `/user/bonus/new-life/${encodeURIComponent(payload.accountCode)}/respawn`, {
            email: payload.email,
        });
        yield put(setNewLifeRespawnSuccess(data));
        yield put(pushGtmEventAction({
            event: 'success_respawn',
            module: 'RespawnPage',
            account_type: parsedAccount.type,
        }));
    } catch (e) {
        yield put(pushGtmEventAction({
            event: 'errorConfirmEmail',
            module: 'RespawnPage',
            error: e.response?.data?.messageCode,
            account_type: parsedAccount.type,
        }));
        yield call(failurePut, e, setNewLifeRespawnFailure);
    }
}

export function* bonusesSagas() {
    yield takeEvery(GET_NEW_LIFE_ACCOUNTS_START, getNewLifeAccountsSaga);
    yield takeEvery(SET_NEW_LIFE_RESPAWN_START, setNewLifeRespawnSaga);
}
